import { useParams } from 'react-router-dom';

import { HistoryTab } from '@/components/deploy/history-tab';

export function ProjectHistoryPage() {
  const { projectKey } = useParams<{ projectKey: string }>();
  const key = projectKey ?? '';

  return (
    <main id="main-content" className="mx-auto max-w-5xl">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-content">Deployment History</h1>
        <p className="mt-1 text-sm text-content-secondary">
          View past deployments and their outcomes
        </p>
      </header>

      <HistoryTab projectKey={key} />
    </main>
  );
}
